import api from "@/services/api";

export const state = {
  associationHistoryChanges: [],
};

export const mutations = {
  INIT_ASSOCIATION_HISTORY_CHANGES(state, payload) {
    state.associationHistoryChanges = payload;
  },
  
};

export const actions = {
  getAssociationsHistoryChanges({ commit }, payload) {
    return api.getAssociationsHistoryReport(payload).then((response) => {
      commit("INIT_ASSOCIATION_HISTORY_CHANGES", response.data.data);

      if (!payload.retrieveAll) commit("pager/INIT_PAGER", response.data.pagedResult, { root: true });
    });
  },
}

export const getters = {
  getAssociationsHistoryChanges: (state) => state.associationHistoryChanges,
  
};
